import { useNavigate } from 'react-router-dom';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const niches = [
  { niche: 'Автосалон', price: '1 300–3 500 ₽', slug: 'avtosalon' },
  { niche: 'Спецтехника', price: '2 000–5 000 ₽', slug: 'spectehnika' },
  { niche: 'Авто с аукционов', price: '1 500–3 000 ₽', slug: 'avto-s-auktsionov' },
  { niche: 'Автошкола', price: '800–2 000 ₽', slug: 'avtoshkola' },
  { niche: 'Застройщики', price: '3 000–10 000 ₽', slug: 'zastroyschiki' },
  { niche: 'Строительство домов', price: '2 500–5 000 ₽', slug: 'stroitelstvo-domov' },
  { niche: 'Производство бань', price: '1 000–2 000 ₽', slug: 'proizvodstvo-ban' },
  { niche: 'Производство окон', price: '1 000–2 000 ₽', slug: 'proizvodstvo-okon' },
  { niche: 'Производство кухонь', price: '2 000–3 500 ₽', slug: 'proizvodstvo-kuhon' },
  { niche: 'Стоматология: имплантация', price: '1 400–2 500 ₽', slug: 'stomatologiya-implantatsiya' },
  { niche: 'Фитнес-зал', price: '900–1 400 ₽', slug: 'fitnes-zal' },
  { niche: 'Юридические услуги, БФЛ', price: '1 000–1 900 ₽', slug: 'yuridicheskie-uslugi-bfl' },
  { niche: 'Образование', price: '700–1 800 ₽', slug: 'obrazovanie' },
  { niche: 'Туризм', price: '900–2 000 ₽', slug: 'turizm' },
  { niche: 'Онлайн школы', price: '1 000–5 000 ₽', slug: 'onlayn-shkoly' },
  { niche: 'B2B', price: '2 000–10 000 ₽', slug: 'b2b' },
];

export default function LTKNiches() {
  const navigate = useNavigate();

  const { ref: labelRef, revealed: labelRevealed } = useScrollReveal();
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal({ delay: 100 });
  const { ref: listRef, revealed: listRevealed } = useScrollReveal({ delay: 200 });
  const { ref: noteRef, revealed: noteRevealed } = useScrollReveal({ delay: 300 });

  const handleSelect = (slug: string) => {
    navigate(`/niches/${slug}`);
  };

  return (
    <section className="py-12 sm:py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 md:px-10">
        <div className="text-center mb-6 sm:mb-8 md:mb-10">
          <span ref={labelRef} className={`text-[11px] sm:text-[12px] font-semibold uppercase tracking-[0.18em] text-primary-600 reveal-fade-up ${labelRevealed ? 'revealed' : ''}`}>
            Ниши и стоимость
          </span>
          <h2 ref={titleRef} className={`mt-3 font-display font-extrabold text-[22px] sm:text-[26px] md:text-[38px] leading-[1.1] tracking-tightest text-foreground-950 reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}>
            Работаем с 16 нишами — найдите свою
          </h2>
        </div>

        <div ref={listRef} className={`max-w-3xl mx-auto reveal-fade-up ${listRevealed ? 'revealed' : ''}`}>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3">
            {niches.map((item) => (
              <button
                key={item.slug}
                type="button"
                onClick={() => handleSelect(item.slug)}
                className="flex items-center justify-between gap-3 px-4 sm:px-5 py-3 sm:py-3.5 rounded-xl border border-background-200 bg-background-50 hover:border-primary-400 hover:shadow-sm transition-all duration-200 text-left cursor-pointer group"
              >
                <span className="text-[13px] sm:text-[14px] md:text-[15px] text-foreground-900 font-medium leading-snug break-words">{item.niche}</span>
                <div className="flex items-center gap-2 shrink-0">
                  <span className="text-[12px] sm:text-[13px] font-semibold text-foreground-600 whitespace-nowrap">{item.price}</span>
                  <span className="w-5 h-5 rounded-full bg-background-100 flex items-center justify-center text-foreground-400 group-hover:text-primary-500 group-hover:bg-primary-100 transition-colors">
                    <i className="ri-arrow-right-s-line text-xs"></i>
                  </span>
                </div>
              </button>
            ))}
          </div>
        </div>

        <p ref={noteRef} className={`mt-5 text-center text-[12px] sm:text-[13px] text-foreground-500 max-w-xl mx-auto reveal-fade-up ${noteRevealed ? 'revealed' : ''}`}>
          Цены ориентировочные. Точный расчёт зависит от региона, среднего чека, конкуренции и критериев целевого клиента.
        </p>

        <p className="mt-3 text-center text-[12px] sm:text-[13px] text-foreground-600 max-w-xl mx-auto">
          Если вашей ниши нет в списке —{' '}
          <a
            href="https://t.me/anna_aigam"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary-600 font-semibold hover:text-primary-500 underline underline-offset-2 transition-colors cursor-pointer"
          >
            уточните у менеджера
          </a>
        </p>
      </div>
    </section>
  );
}